"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";
export function Providers(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  const [queryClient] = useState(_temp);
  let t1;
  if ($[0] !== children || $[1] !== queryClient) {
    t1 = <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
    $[0] = children;
    $[1] = queryClient;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
function _temp() {
  return new QueryClient();
}